import { Injectable } from '@angular/core';
import { StockMovesService } from '@kinet-open-network/client/stock-moves/data-access';
import {
  ApiPaginatedResponse,
  ApiQuery,
  paginatedFromArray,
} from '@kinet-open-network/shared/data-access/api';
import { StockType } from '@kinet-open-network/shared/data-access/model';
import {
  FILLING_PLANT_ID,
  FILLING_PLANT_LABEL,
  PbgasStockType,
} from '@kinet-open-network/shared/data-access/model-pbgas';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppStockMovesService extends StockMovesService {
  override queryStockOptions(
    stockType?: StockType,
    q?: ApiQuery | null,
  ): Observable<ApiPaginatedResponse<{ label: string; id: string }>> {
    if (stockType === PbgasStockType.fillingPlant) {
      return of(
        paginatedFromArray([
          { label: FILLING_PLANT_LABEL, id: FILLING_PLANT_ID },
        ]),
      );
    }

    return super.queryStockOptions(stockType, q);
  }
}
